import React from 'react';
import navigationService from '../../services/NavigationService';

class InvisibleNextButton extends React.PureComponent {
    render() {
        const disableNext = navigationService.isOnFinalStepPage()
            || (navigationService.isOnLastQuestion() && !navigationService.isFinalStepAvailable());

        return (
            <button
                style={{ opacity: 0 }}
                disabled={disableNext}
                id="invisible-nav-button-next"
                title="next"
                onClick={navigationService.navigateToNextStep}
            >
                {'next'}
            </button>
        );
    }
}

export default InvisibleNextButton;
